module.exports = __webpack_public_path__ + "static/media/GO_C_clusters_plot.be1ea0f3.png";